(function () {
  if (window.__moxLoadMoreStable) return;
  window.__moxLoadMoreStable = true;

  const gridSelector = 'hdt-reval-items';
  const btnSelector = '.hdt-loamore-btn';

  function enhanceButton(btn) {
    if (btn.__moxEnhanced) return;
    btn.__moxEnhanced = true;

    const originalHTML = btn.innerHTML;

    btn.addEventListener('click', () => {
      btn.innerHTML = `
        <span style="display:inline-flex;align-items:center;gap:10px;">
          <span style="
            width:16px;height:16px;
            border:3px solid #da2128;
            border-top-color:transparent;
            border-radius:50%;
            animation:moxSpin .8s linear infinite;
          "></span>
          <span>Cargando…</span>
        </span>
      `;
    });

    // Cuando llegan nuevos productos → restaurar
    const grid = document.querySelector(gridSelector);
    if (!grid) return;

    const mo = new MutationObserver(() => {
      btn.innerHTML = originalHTML;
    });

    mo.observe(grid, { childList: true, subtree: true });
  }

  // keyframes inline (una sola vez)
  if (!document.getElementById('moxSpinStyle')) {
    const st = document.createElement('style');
    st.id = 'moxSpinStyle';
    st.textContent = `@keyframes moxSpin{to{transform:rotate(360deg)}}`;
    document.head.appendChild(st);
  }

  // Observer global: cada vez que Ecomus re-renderiza el botón
  const globalMO = new MutationObserver(() => {
    document.querySelectorAll(btnSelector).forEach(enhanceButton);
  });

  globalMO.observe(document.body, { childList: true, subtree: true });

  // Primera pasada
  document.querySelectorAll(btnSelector).forEach(enhanceButton);
})();
